import React from "react";
import { Breadcrumbs, Grid, Typography, Link } from "@mui/material";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";

function BreadcrumbBar(props: { children?: any; window?: any; links: Array<any>; Titulo: string }) {
  const navigate = useNavigate();
  return (
    <Grid sx={{}} item>
      <Breadcrumbs aria-label="breadcrumb">
        {
          props.links.map((l: any, i: number) => {
            return (
              l.link !== "#" ?
                <Link key={i} underline="hover" color="inherit" onClick={() => navigate(l.link)} style={{ cursor: 'pointer' }}>
                  {l.texto}
                </Link>
                :
                <Typography key={i} color="text.primary"> {l.texto} </Typography>
            )
          })
        }

        <Typography color="text.primary">{props.Titulo} </Typography>
      </Breadcrumbs>
    </Grid>
  );
}

BreadcrumbBar.propTypes = {
  window: PropTypes.func,
};

export default BreadcrumbBar;
